// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export interface CurrencyFormater {
  format: (value: number, isNew?: boolean) => string;
}

export interface GbpToTargetCurrency {
  convertAndFormat: (value: number) => string;
  convert: (value: number) => number;
}

export type ObjectType = Record<string, unknown>;

export enum PORTAL_DESCRIPTIONS {
  PORTAL_INVEST = 'PORTAL_INVEST',
  PORTAL_BUY_TRADE = 'PORTAL_BUY_TRADE',
  PORTAL_BUY_PORTFOLIO = 'PORTAL_BUY_PORTFOLIO',
  PORTAL_ACCEPTBID_PORTFOLIO = 'PORTAL_ACCEPTBID_PORTFOLIO',
  PORTAL_ACCEPTBID_TRADE = 'PORTAL_ACCEPTBID_TRADE',
}
